import axios from 'axios';

export class ResultadosFinais {

  static async buscaResultadosFinais(turmaId, disciplinaId = 0) {
    const ano = parseInt(sessionStorage.getItem("anoSelecionado"));
    return axios.get(`/dados-semestrais/${ano}/${turmaId}/${disciplinaId}`)
  }
}
